import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";

@Component({
  selector: 'generic-button-toggles',
  styleUrls: ['./generic-button-toggles.component.css'],
  templateUrl: './generic-button-toggles.component.html',
})
export class GenericButtonTogglesComponent implements OnChanges {
  @Input() title: string = '';
  @Input() options: string[] = [];
  @Input() initialSelection: string = '';
  @Input() disabled: boolean = false;
  @Output() selectionChange = new EventEmitter<string>();

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      this.disabled = changes.disabled.currentValue;
    }
  }

  onToggleChange(event: any) {
    this.selectionChange.emit(event.value);
  }
}